import React from 'react'
import FormCore from 'components/Form/Core'
import Table from 'components/Form/Table'
import Button from 'components/Form/Button'
import { ListSkeleton } from 'components/Skeleton'
import { ButtonContainer } from 'ui/styled'
import { PageHeader, PageIntro, PageTitle, PageSubtitle, State, StateTitle, StateText } from '../UserApprovals/styled'
import { Page, RequestForm, AccessTable } from './styled'
import useController from './controller'
import ManagedUsers from './ManagedUsers'

export default function AccessProfiles() {
  const { t, identity, rows, formItems, formRef, loading, saving, error, load, submit, enterArea, managementChanged } = useController()
  return (
    <Page>
      <PageHeader>
        <PageIntro><PageTitle>{t('identity_access_title')}</PageTitle><PageSubtitle>{t('identity_access_subtitle')}</PageSubtitle></PageIntro>
        <Button outline width="auto" small nospace onClick={load} disabled={loading}>{t('user_approvals_refresh')}</Button>
      </PageHeader>
      {loading ? <ListSkeleton rows={3} /> : error ? (
        <State><StateTitle>{t('identity_access_unavailable')}</StateTitle><StateText>{t('user_approvals_load_error')}</StateText></State>
      ) : (
        <>
          <AccessTable><Table analytical minWidth={0} pagination={false} rows={rows} columns={[
            { title: t('identity_access_area'), ref: 'label' },
            { title: t('user_approvals_status'), ref: 'displayStatus' },
            ...(rows.filter(row => row.enabled && row.status === 'active').length > 1 ? [{ title: t('user_approvals_actions'), ref: 'actions', renderCell: ({ row }) => row.enabled && row.status === 'active'
              ? <Button outline width="auto" small nospace onClick={() => enterArea(row.area)}>{t('identity_access_enter')}</Button> : null }] : []),
          ]} /></AccessTable>
          {!identity?.requestsEnabled || !rows.some(row => row.area === 'universe' && row.enabled && row.status === 'none') ? null : (
            <section>
              <StateTitle>{t('identity_request_universe')}</StateTitle>
              <StateText>{t('identity_request_explanation')}</StateText>
              <RequestForm><FormCore ref={formRef} formItems={formItems} register={identity.profile} disabled={saving} /></RequestForm>
              <ButtonContainer><Button color="blue" onClick={submit} loading={saving} disabled={saving}>{t('identity_request_submit')}</Button></ButtonContainer>
            </section>
          )}
          {identity?.manageableAreas?.length ? <ManagedUsers areas={identity.manageableAreas} canInvite={identity.invitationsEnabled} t={t} onChanged={managementChanged} /> : null}
        </>
      )}
    </Page>
  )
}
